import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import 'zingchart/es6';
import zing from 'zingchart-vue';
// import firebase  from 'firebase'
import {auth} from './components/firebaseinit'
//import { directive } from 'vue/types/umd';

Vue.config.productionTip = false
Vue.component('zingchart',zing);
Vue.directive('rainbow',{
  bind(el){
    el.style.backgroundColor="#"+Math.random().toString().slice(2,8)
  }
})

let app;
auth.onAuthStateChanged(user => {
  console.log(user)
  if(!app){
    app=new Vue({
      router,
      vuetify,
      render: h => h(App)
    }).$mount('#app')
     
  }
})



// Vue.directive('buttu',{
//   bind(el){
//     el.style.bottom="0px";
//   }
// });